<template>
	<div class="container-fullscreen footer footer-dark">
		<div class="half-bottom text-center">
			<p class="text-center">
				<img
					src="../assets/images/logo-white.png"
					data-displaymode="Original"
					alt="logo"
					title="logo"
				/>
			</p>
		</div>
		<div class="small-text text-center">
			<a href="/account/TermsAndConditions">Política de privacidad</a>
		</div>
		<div class="small-text no-bottom text-center">CASI©2023</div>
	</div>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>

<style scoped>

</style>
